import React from "react";
import { ArrowUpRight, Chrome } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function CTA() {
    const { t } = useTranslation();
    return (
        <section
            id="cta"
            className="scroll-mt-20 border-b-2 border-black bg-black text-white relative overflow-hidden"
            data-testid="cta-section"
        >
            <div
                className="absolute inset-0 opacity-[0.08] pointer-events-none"
                style={{
                    backgroundImage:
                        "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
                    backgroundSize: "48px 48px",
                }}
            />
            <div className="relative mx-auto max-w-[1400px] grid grid-cols-12">
                <div className="col-span-12 md:col-span-7 border-r-0 md:border-r-2 border-b-2 md:border-b-0 border-white p-8 md:p-16">
                    <span className="font-mono text-xs tracking-[0.25em] uppercase border-2 border-white bg-[#FFCC00] text-black px-3 py-1 inline-block">
                        {t("landing.cta.eyebrow")}
                    </span>
                    <h2 className="mt-6 font-display text-5xl md:text-7xl lg:text-8xl uppercase leading-[0.9] tracking-tighter">
                        {t("landing.cta.headlineLine1")}
                        <br />
                        {t("landing.cta.headlineLine2") && <>{t("landing.cta.headlineLine2")}<br /></>}
                        <span className="inline-block bg-[#FFCC00] px-3 py-1" style={{ color: '#1c1b1a' }}>
                            {t("landing.cta.headlineHighlight")}
                        </span>
                    </h2>
                    <p className="mt-8 max-w-xl text-base md:text-lg text-zinc-300 leading-relaxed">
                        {t("landing.cta.description")}
                    </p>
                </div>
                <div className="col-span-12 md:col-span-5 p-8 md:p-16 flex flex-col justify-end gap-4">
                    <a
                        href="/sign-up"
                        data-testid="cta-signup"
                        className="btn-brutal flex items-center justify-between border-2 border-white bg-[#FFCC00] text-black px-8 py-6 font-mono text-sm uppercase tracking-[0.25em] shadow-brutal-white hover:bg-[#e6b800]"
                    >
                        <span>{t("landing.cta.ctaSignup")}</span>
                        <ArrowUpRight size={20} />
                    </a>
                    <a
                        href="/sign-up"
                        data-testid="cta-extension"
                        className="btn-brutal flex items-center justify-between border-2 border-white bg-black text-white px-8 py-6 font-mono text-sm uppercase tracking-[0.25em] shadow-brutal-white hover:bg-zinc-900 hover:text-[#FFCC00]"
                    >
                        <span className="flex items-center gap-3">
                            <Chrome size={18} /> {t("landing.cta.ctaExtension")}
                        </span>
                        <ArrowUpRight size={20} />
                    </a>
                    <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-400 mt-4">
                        {t("landing.cta.noCreditCard")}
                    </div>
                </div>
            </div>
        </section>
    );
}
